import { render, staticRenderFns } from "./ActivityTab.vue?vue&type=template&id=c4772eac"
import script from "./ActivityTab.vue?vue&type=script&lang=js"
export * from "./ActivityTab.vue?vue&type=script&lang=js"
import style0 from "./ActivityTab.vue?vue&type=style&index=0&id=c4772eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports